export type ClassifiedsMarketType = "sale" | "rent";
export type ClassifiedsListingType =
  | "house"
  | "land_plot"
  | "apartment"
  | "commercial";

export type ClassifiedsFilterCapabilities = {
  priceSqm: boolean;
  priceMonthly: boolean;
  area: boolean;
  utilitiesPayer: boolean;
  rentTerm: boolean;
  agentCommission: boolean;
  commissionSort: boolean;
  hasImage: boolean;
};

/**
 * Determines which catalog filters describe listings in the selected taxonomy scope.
 * A rent-term filter is intentionally unavailable until a specific non-commercial
 * category or subcategory is selected: commercial rentals do not have this field.
 */
export const getClassifiedsFilterCapabilities = (
  marketType: ClassifiedsMarketType,
  listingType: ClassifiedsListingType | null,
): ClassifiedsFilterCapabilities => {
  const isRent = marketType === "rent";

  return {
    priceSqm: marketType === "sale",
    priceMonthly: isRent,
    area: true,
    utilitiesPayer: isRent,
    rentTerm: isRent && listingType !== null && listingType !== "commercial",
    agentCommission: isRent,
    // Sorting by publication date is available for every market section.
    // Rental-only sort options are controlled separately in the UI.
    commissionSort: true,
    hasImage: true,
  };
};
